import { ContentType } from '../../enums/content-type.enum';
import { ContentTypeProvider } from './../../enums/content-type.enum';
import { Content, IContent } from './content.model';
import { IUpdateContentPayload } from './update-content-payload.model';

export interface IUpdateContentVideoPayload extends Omit<IUpdateContentPayload, 'type'> {
  type: ContentType.VIDEO;
  url: string;
  duration: number;
  provider: ContentTypeProvider;
  thumbnailImageUrl: string;
}

export interface IContentVideo extends IContent {
  url: string;
  duration?: number;
  provider: ContentTypeProvider;
  thumbnailImageUrl?: string;
}

export class ContentVideo extends Content {
  constructor(
    public override id: string,
    public override createdAt: Date,
    public override updatedAt: Date,
    public override title: string,
    public override description: string,
    public override type: ContentType,
    public override blocked: boolean,
    public url: string,
    public provider: ContentTypeProvider,
    public duration?: number,
    public thumbnailImageUrl?: string,
  ) {
    super(id, createdAt, updatedAt, title, description, type, blocked);
  }

  public static Build(content: IContentVideo): ContentVideo {
    return new this(
      content.id,
      new Date(content.createdAt),
      new Date(content.updatedAt),
      content.title,
      content.description,
      content.type,
      content.blocked,
      content.url,
      content.provider,
      content.duration,
      content.thumbnailImageUrl,
    );
  }
}
